import React, { createContext } from 'react';
import { CardFilter, statusRange, orderKeys } from 'api/card';

type Props = {
  cardFilter: CardFilter,
  setCardFilter: React.Dispatch<React.SetStateAction<CardFilter>>,
  loadCards: (filter: CardFilter) => void,
};

export const defaultCardFilter: CardFilter = {
  name_or_text: '',
  name_search: true,
  w: false,
  u: false,
  b: false,
  r: false,
  g: false,
  colorless: false,
  multicolored: false,
  colorIdentity: false,
  cost0: false,
  cost1: false,
  cost2: false,
  cost3: false,
  cost4: false,
  cost5: false,
  cost6: false,
  cost7: false,
  cost8: false,
  cost9: false,
  costOver10: false,
  supertypes: [],
  types: [],
  subtypes: [],
  powerFr: statusRange[0],
  powerTo: statusRange[0],
  toughnessFr: statusRange[0],
  toughnessTo: statusRange[0],
  order: orderKeys[0],
  orderASC: true,
  pageSize: 50,
  page: 1,
};


export const CardFilterContext = createContext<Props>({
  cardFilter: defaultCardFilter,
  setCardFilter: () => {
    console.log('init card filter context')
  },
  loadCards: () => {
    console.log('init card filter context')
  },
});
